/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * Multipart completion record for one uploaded part.
 * @export
 * @interface CompletedUploadPart
 */
export interface CompletedUploadPart {
    /**
     * S3 multipart upload part number.
     * @type {number}
     * @memberof CompletedUploadPart
     */
    partNumber: number;
    /**
     * Opaque ETag value returned by S3 for a successful upload.
     * @type {string}
     * @memberof CompletedUploadPart
     */
    eTag: string;
}


/**
 * Check if a given object implements the CompletedUploadPart interface.
 */
export function instanceOfCompletedUploadPart(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partNumber" in value;
    isInstance = isInstance && "eTag" in value;
    return isInstance;
}

export function CompletedUploadPartFromJSON(json: any): CompletedUploadPart {
    return CompletedUploadPartFromJSONTyped(json, false);
}

export function CompletedUploadPartFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletedUploadPart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'partNumber': json['partNumber'],
        'eTag': json['eTag'],
    };
}

export function CompletedUploadPartToJSON(value?: CompletedUploadPart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'partNumber': value.partNumber,
        'eTag': value.eTag,
    };
}

